const { ccclass, property } = cc._decorator;
import ViewBase from "../../../../framework/core/mvvm/view_base";
import { ListView, ListViewDir } from "../../../../framework/tools/scrollview/listview"
import UserDataManager from "../../../../manager/user_manager";
import ModelData from "../../../public/model_data";
import TextureManager from "../../../../manager/texture_manager";
import SpriteFrameHolder from "../../../public/ui/spriteFrameHolder";
import Utility from "../../../../utility/utility";

@ccclass
export default abstract class CaiChiView extends ViewBase {
    @property(SpriteFrameHolder)
    iconSprFrameHolder:SpriteFrameHolder = null

    @property(cc.Label)
    caichiNumLab:cc.Label  = null

    @property(cc.Label)
    biliLab:cc.Label  = null

    @property(cc.Sprite)
    typeIcons:cc.Sprite[] = []

    @property(cc.Label)
    amoutLab: cc.Label = null

    @property(cc.Label)
    timeLab:cc.Label = null

    @property(cc.ScrollView)
    scrollview: cc.ScrollView = null;

    @property(cc.Node)
    view: cc.Node = null;

    @property(cc.Node)
    content: cc.Node = null;

    @property(cc.Node)
    prefab: cc.Node = null;

    @property(cc.Node)
    noTips:cc.Node = null

    m_list: ListView = null

    isFreeGame = false

    onLoad() {
        let list: ListView = new ListView({
            scrollview: this.scrollview,
            view: this.view,
            content: this.content,
            item_prefab: this.prefab,
            cb_host: this,
            item_update_func: this.update_list_item,
            select_cb: this.on_item_select,
            column: 3,
            row: 1,
            gap_x: 30,
            gap_y: 20,
            direction: ListViewDir.Vertical,
        });
        this.m_list = list
        


    }
    
    on_item_select(data: any, index: number) {
        //cc.log(data, index);
    }


    initShow(data, isTb, isFreeGame){
        this.isFreeGame = isFreeGame
       this.biliLab.string = data.jackpotRatio * 100 + "%POT"
       this.amoutLab.string =  data.num ? data.num + "" : ""
       this.timeLab.string = data.time ? Utility.formatTime(data.time) :""

       this.amoutLab.node.active = this.amoutLab.string != ""
       this.timeLab.node.active = this.timeLab.string != ""
       if(data.result){
            let resultList = this.disposeData(data.result)
            this.typeIcons[0].spriteFrame = this.iconSprFrameHolder.getSpriteFrameByKey((isTb ? (resultList[0] + 6): resultList[0]) +"" )
            this.typeIcons[1].spriteFrame = this.iconSprFrameHolder.getSpriteFrameByKey((isTb ? (resultList[1] + 6): resultList[1]) +"" )
            this.typeIcons[2].spriteFrame = this.iconSprFrameHolder.getSpriteFrameByKey((isTb ? (resultList[2] + 6): resultList[2]) +"" )
            
            this.typeIcons[0].node.active = true
            this.typeIcons[1].node.active = true
            this.typeIcons[2].node.active = true
       }else{
            this.typeIcons[0].node.active = false
            this.typeIcons[1].node.active = false
            this.typeIcons[2].node.active = false
       }
      
    }

     //拆出一局开出的结果  服务器给的值如“123” 表示这一局开出的结果为  1， 2, 3
     disposeData(data){
        let ret:number[] =[]
        let dataString = String(data)
        ret[0] = Number(dataString[0])
        ret[1] = Number(dataString[1])
        ret[2] = Number(dataString[2])
        return ret
    }

    updateShow(m_Data:any = null){
        if (m_Data == null){ 
            this.noTips.active = true
            return 
        }
        this.noTips.active = false
        this.m_list.set_data(m_Data);
        this.m_list.select_item(1)
        this.m_list.scroll_to(0)
    }

    update_list_item(item: cc.Node, data: any, index: number): void {
        let self = this
        let rank = cc.find("IndexBg/RankIndex", item).getComponent(cc.Label)
        let head = cc.find("Avatar/Mask/SpriteAvatar", item).getComponent(cc.Sprite)
        let name = cc.find("Name", item).getComponent(cc.Label)
        let count = cc.find("Count", item).getComponent(cc.Label)
        let countSpr = cc.find("Icon", item).getComponent(cc.Sprite)
        countSpr.spriteFrame = this.iconSprFrameHolder.getSpriteFrameByKey(this.isFreeGame ? "Gold" : "Bet" )
        rank.string = index + 1  + ""
        name.string = data.userData.nick_name
        count.string = data.num ? data.num +"" : "0"

        if ( data.userData.img.indexOf("http") == -1) {
            head.spriteFrame =  ModelData.instance.getPlayerIconByName(data.userData.img)
        } else {
            TextureManager.instance.getSprite(data.userData.img, (sprite) => {
                if(self.node){
                    head.spriteFrame = sprite
                }
               
            })
        }
       
    }

}